"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertiesStatsEstimatedValuesWrapper$ = exports.PropertiesStatsEstimatedValuesWrapper$outboundSchema = exports.PropertiesStatsEstimatedValuesWrapper$inboundSchema = void 0;
exports.propertiesStatsEstimatedValuesWrapperToJSON = propertiesStatsEstimatedValuesWrapperToJSON;
exports.propertiesStatsEstimatedValuesWrapperFromJSON = propertiesStatsEstimatedValuesWrapperFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const fastapikrakenendpointsstatsmodelsgetpropertiesresponsesstatslatestestimate_js_1 = require("./fastapikrakenendpointsstatsmodelsgetpropertiesresponsesstatslatestestimate.js");
const propertiesstatsestimatedvalues_js_1 = require("./propertiesstatsestimatedvalues.js");
const statsdelta_js_1 = require("./statsdelta.js");
/** @internal */
exports.PropertiesStatsEstimatedValuesWrapper$inboundSchema = z.object({
    delta: statsdelta_js_1.StatsDelta$inboundSchema,
    latest_estimate: fastapikrakenendpointsstatsmodelsgetpropertiesresponsesstatslatestestimate_js_1.FastapiKrakenEndpointsStatsModelsGetPropertiesResponsesStatsLatestEstimate$inboundSchema,
    values: z.array(propertiesstatsestimatedvalues_js_1.PropertiesStatsEstimatedValues$inboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "latest_estimate": "latestEstimate",
    });
});
/** @internal */
exports.PropertiesStatsEstimatedValuesWrapper$outboundSchema = z.object({
    delta: statsdelta_js_1.StatsDelta$outboundSchema,
    latestEstimate: fastapikrakenendpointsstatsmodelsgetpropertiesresponsesstatslatestestimate_js_1.FastapiKrakenEndpointsStatsModelsGetPropertiesResponsesStatsLatestEstimate$outboundSchema,
    values: z.array(propertiesstatsestimatedvalues_js_1.PropertiesStatsEstimatedValues$outboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        latestEstimate: "latest_estimate",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PropertiesStatsEstimatedValuesWrapper$;
(function (PropertiesStatsEstimatedValuesWrapper$) {
    /** @deprecated use `PropertiesStatsEstimatedValuesWrapper$inboundSchema` instead. */
    PropertiesStatsEstimatedValuesWrapper$.inboundSchema = exports.PropertiesStatsEstimatedValuesWrapper$inboundSchema;
    /** @deprecated use `PropertiesStatsEstimatedValuesWrapper$outboundSchema` instead. */
    PropertiesStatsEstimatedValuesWrapper$.outboundSchema = exports.PropertiesStatsEstimatedValuesWrapper$outboundSchema;
})(PropertiesStatsEstimatedValuesWrapper$ || (exports.PropertiesStatsEstimatedValuesWrapper$ = PropertiesStatsEstimatedValuesWrapper$ = {}));
function propertiesStatsEstimatedValuesWrapperToJSON(propertiesStatsEstimatedValuesWrapper) {
    return JSON.stringify(exports.PropertiesStatsEstimatedValuesWrapper$outboundSchema.parse(propertiesStatsEstimatedValuesWrapper));
}
function propertiesStatsEstimatedValuesWrapperFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PropertiesStatsEstimatedValuesWrapper$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PropertiesStatsEstimatedValuesWrapper' from JSON`);
}
//# sourceMappingURL=propertiesstatsestimatedvalueswrapper.js.map